// Cookie notice + analytics bootstrap.
// The banner is informational only (implied consent): Yandex.Metrika and
// Sentry start immediately on app load, no opt-in required.
import * as Sentry from '@sentry/react';
import {SENTRY_DSN} from '../config/env';

const NOTICE_KEY = 'cookie_notice_shown_v1';

const DOMAIN_COUNTER_MAP = {
    'selebrus.ru': 106567758,
    'xn--90ahax1abfp.xn--p1ai': 108170525,       // селебрус.рф
};

function getCounterId() {
    return DOMAIN_COUNTER_MAP[window.location.hostname] || 106567758;
}

export function wasCookieNoticeShown() {
    try {
        return Boolean(localStorage.getItem(NOTICE_KEY));
    } catch {
        return false;
    }
}

export function markCookieNoticeShown() {
    try {
        localStorage.setItem(NOTICE_KEY, '1');
    } catch {
        /* storage unavailable — the notice will simply show again next visit */
    }
}

let metrikaLoaded = false;

function loadYandexMetrika() {
    if (metrikaLoaded || typeof window === 'undefined') return;
    metrikaLoaded = true;
    const cid = getCounterId();
    (function (m, e, t, r, i, k, a) {
        m[i] = m[i] || function () {
            (m[i].a = m[i].a || []).push(arguments);
        };
        m[i].l = 1 * new Date();
        k = e.createElement(t);
        a = e.getElementsByTagName(t)[0];
        k.async = 1;
        k.src = r;
        a.parentNode.insertBefore(k, a);
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js?id=' + cid, 'ym');

    window.ym(cid, 'init', {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: 'dataLayer',
        accurateTrackBounce: true,
        trackLinks: true,
    });

    window.__ymCounterId = cid;
}

let sentryLoaded = false;

function initSentry() {
    if (sentryLoaded || !import.meta.env.PROD) return;
    sentryLoaded = true;
    Sentry.init({
        dsn: SENTRY_DSN,
    });
}

// Start all analytics/monitoring. Called unconditionally on app load.
export function enableAnalytics() {
    loadYandexMetrika();
    initSentry();
}
